<header [preLogin]="true"></header>
<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
        <!-- <left-panel-onboarding></left-panel-onboarding> -->
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <grid-row class="mt-30">
                <grid-col col="12">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "PleaseSelctYourReason" | translate }}
                    </div>
                    <grid-col col="3" >
                        <div class="form-group mt-20" >
                            <drop-down-list borderRadius="br-100" dropDownImage="false" dropDownSearch="false"
                                [selectedValue]="this.selectedDecline" [dropDownData]="this.DeclineList"
                                (itemselected)="onDeclineChange($event)">
                                {{this.selectedDecline}}
                            </drop-down-list>
                        </div>
                    </grid-col>
                </grid-col>
            </grid-row>


           
            <grid-row class="justify-content-between align-item-center mt-50">
                <grid-col col="auto">
                    <div class="mt-15">
                        <button class="btn-back" (click)="back()">
                            <i class="icon-back"></i>
                        </button>
                    </div>
                </grid-col>
                <grid-col col="9">
                    <!-- (click)="showModal(2)" -->
                    <button class="btn-dft" [disabled]="this.selectedDecline == '' || this.selectedDecline == undefined"   (click)="DeclineLimit()">
                        {{ "Next" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>